import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global styles
//import './style.css';
import './style/base.css';
import './style/navbar.css';
import './style/pages.css';
import './style/responsive.css';
import './style/sidebar.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>    
    <App />
  </React.StrictMode>
);
